import axios from 'axios'
import { handleAxiosPromise, apiConfig } from '@/utils/api-common'

const BASE_URL = process.env.BOOLEAN2D_SERVER
const url = `${BASE_URL}/api/pubmed-count?terms=`

export function pubmedGetCount (terms) {
  if (terms && typeof terms === 'object' && Array.isArray(terms)) {
    const promises = []
    const ac = apiConfig()
    const counts = []
    terms.forEach(t => {
      promises.push(new Promise((resolve, reject) => {
        const p = handleAxiosPromise(axios.get(url + encodeURIComponent(t.terms), ac))
        p.then(
          response => {
            counts.push({key: t.key, count: response.response.count, terms: t.terms})
            resolve()
          },
          response => reject(response.status)
        ).catch(reason => {
          reject(reason)
        })
      }))
    })
    return new Promise((resolve, reject) => {
      Promise.all(promises).then(
        response => {
          resolve(counts)
        },
        response => {
          console.warn('Not all promises worked', response)
          reject(new Error('Unable to fetch counts'))
        }
      )
    })
  } else {
    return new Promise((resolve, reject) => {
      resolve([])
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/pubmed-api.js